import { mapGetters, mapMutations } from "vuex";
import alertHelper from "@/helper/AlertHelper";
import Common from "@/common";

export const createShaparakTransactionMixin = {
  data() {
    return {
      paymentId: "",
      creditCardInfo: [
        { length: 4, value: "" },
        { length: 4, value: "" },
        { length: 4, value: "" },
        { length: 4, value: "" },
      ],
      options: [],
      selectedAmount: null,
      bankImageSource: "",
      checkIfInputNotEmpty: false,
      secondContainerVisibility: false,
      mobileNumber: "",
      mobileNumberValidation: false,
    };
  },
  computed: {
    ...mapGetters([
      "getGatewayPendingFlag",
      "getShaparakAmounts",
      "isCreditCardReceivedFromServer",
      "isShetabAmountsReceivedFromServer",
      "isPhoneNumberReceivedFromServer",
      "getPayingAmount",
      "getCompleteCreditCardNumber",
      "getCallBackUrl",
      "getSitesApiResult",
    ]),
    shaparakCommissionFee() {
      return this.getSitesApiResult?.data?.settings
        ?.shaparak_commission_shop_fee;
    },
    shaparakCommissionFeeText() {
      if (!this.shaparakCommissionFee || this.shaparakCommissionFee === null)
        return null;
      // Fetch the translation and manually replace the placeholder
      const translation = this.$translate("shaparakCommissionFee");
      return translation.replace(
        "{shaparakCommissionFee}",
        this.shaparakCommissionFee
      );
    },
  },
  methods: {
    ...mapMutations([
      "setShaparakCompleteCreditCardNumber",
      "setShaparakPayingAmount",
      "setStepperPage",
      "setTransactionId",
    ]),
    useThisCardFromStore(cardInfo) {
      for (let i = 0; i < this.creditCardInfo.length; i++) {
        let splitedCardInfo = cardInfo.match(/.{1,4}/g);
        this.creditCardInfo[i].value = splitedCardInfo[i];
      }
    },
    handleShaparakFixAmount() {
      const amount =
        this.$options.filters.commaSep(this.selectedAmount) +
        " " +
        this.$translate("toman");
      return amount;
    },
    // init the options
    setSecondImportantData(data) {
      if (data) {
        if (typeof data === "string") {
          let dataArray = Object.values(
            Common.translateMultiNumberStringForSelector(data)
          );
          this.options = dataArray;
        } else if (typeof data === "object") {
          this.options = Common.translateArrayForSelector(data);
        }
      } else return;
    },
    setFirstImportantData() {
      //if string with multiple number splited by ","
      if (this.getPayingAmount) {
        if (
          typeof this.getPayingAmount === "string" &&
          this.getPayingAmount.split(",").length > 0
        ) {
          this.options = Common.translateMultiNumberStringForSelector(
            this.getPayingAmount
          );
        }
      }

      //if paying amount was available (only one value)
      if (this.getPayingAmount) {
        this.selectedAmount = this.getPayingAmount;
      }
      if (this.getCompleteCreditCardNumber) {
        this.useThisCardFromStore(this.getCompleteCreditCardNumber);
      }
      if (this.getMobileNumber) {
        this.mobileNumber = this.getMobileNumber;
      }
    },
    setInputDataIfAvailable(data) {
      this.$nextTick(() => {
        this.setSecondImportantData(data);
      });

      this.$nextTick(() => {
        this.setFirstImportantData();
      });
    },

    onCreditCardPaste(evt, targetVariable) {
      Common.onInfoPaste.call(this, evt, targetVariable);
    },
    handleAutoFocus(index) {
      if (this.creditCardInfo[index].value.length === 4) {
        const nextIndex = index + 1;
        if (nextIndex < this.creditCardInfo.length) {
          this.$nextTick(() => {
            document
              .getElementById(`shaparak-credit-card-input-key${nextIndex}`)
              .focus();
          });
        } else document.getElementById(`mobile-number-input`).focus();
      }
    },
    isCreditCardInputFilled() {
      for (let i = 0; i < this.creditCardInfo.length; i++) {
        if (this.creditCardInfo[i].value.length < 4) {
          return false; // At least one value doesn't meet the condition
        }
      }
      return true; // All values meet the condition
    },
    cancelPayment() {
      alertHelper.loadingAlert();
      const callBackUrl = this.getCallBackUrl;
      if (callBackUrl) {
        window.location.href = Common.createCallback(
          callBackUrl,
          this.paymentId,
          0
        );
      } else {
        this.$http.delete(`payments/${this.paymentId}`).then((result) => {
          window.location.href = Common.createCallback(
            result.data.data.callback_url,
            this.paymentId,
            0
          );
        });
      }
    },
    submitInfo() {
      //secondContainerVisibility indicates the validation of the user entered credit card number
      if (
        !this.isCreditCardInputFilled() ||
        !this.secondContainerVisibility ||
        this.selectedAmount === null ||
        !this.mobileNumberValidation
      ) {
        alertHelper.errorAlert("", "لطفا تمامی فیلد هارا به درستی پر کنید");
      } else {
        let from = "";
        for (let i = 0; i < this.creditCardInfo.length; i++) {
          from += this.creditCardInfo[i].value;
        }
        alertHelper.loadingAlert();
        // const querySecret = this.$route.query.s;
        this.$http
          .post("transactions", {
            payment_id: this.paymentId,
            gateway: "SHAPARAK",
            amount: +this.selectedAmount,
            mobile: this.mobileNumber,
            from: from,
          })
          .then(
            (result) => {
              this.setShaparakCompleteCreditCardNumber(from);
              const transactionId = result.data.data.id;
              this.setTransactionId(transactionId);
              this.setShaparakPayingAmount(this.selectedAmount);
              this.setStepperPage("pageTwo");
              alertHelper.successAlert();
            },
            (error) => {
              alertHelper.apiErrorAlert("", error.body.message);
            }
          );
      }
    },
  },
  watch: {
    mobileNumber(value) {
      this.mobileNumberValidation =
        value.substring(0, 2) === "09" && value.length === 11;
    },
    creditCardInfo: {
      handler(val) {
        [this.checkIfInputNotEmpty, this.bankImageSource] =
          Common.checkWhatBank(this.creditCardInfo);
        const enteredCardNum =
          val[0].value + val[1].value + val[2].value + val[3].value;
        //checking credit card number validation
        if (enteredCardNum.length <= 16 && enteredCardNum.length > 0) {
          this.secondContainerVisibility =
            Common.validateCreditCardNumber(enteredCardNum);
        }
      },
      deep: true,
    },
    getShaparakAmounts(value) {
      console.log(value);
    },
    getGatewayPendingFlag(value) {
      if (!value) {
        //when the page is on the shaparak it self,
        this.setInputDataIfAvailable(this.getShaparakAmounts);
      }
    },
  },
  created() {
    this.paymentId = this.$route.query.id;
    if (!this.paymentId) {
      alertHelper.paymentIdNotValidAlert();
    }
    this.setInputDataIfAvailable(this.getShaparakAmounts);
  },
};
